import React, { Component } from 'react';
import {BrowserRouter as Router, Link, Route} from 'react-router-dom';

export const Menu = () => {
        return (
            <nav id="menu" role="navigation" className="menu">
                <ul>
                    <li><Link to={process.env.PUBLIC_URL + '/dashboard'} >Utama</Link></li>
                    <li><Link to={process.env.PUBLIC_URL + '/data'} >Data</Link></li>
                    <li><Link to={process.env.PUBLIC_URL + '/organisasi'} >Organisasi</Link></li>
                    <li><Link to={process.env.PUBLIC_URL + '/tentang'} >Tentang</Link></li>
                </ul>
            </nav>
        )
}